const statusesEnum = {
  active: 'active',
  inactive: 'inactive',
  no_terms: 'no_terms',
};

const allStatuses = Object.values(statusesEnum);

export { statusesEnum, allStatuses };
